/**
 * Copyright © Pronko Consulting Ltd. All rights reserved.
 */

/**
 * @class PopupFormToggle
 * @classdesc Main class for toggle Custom Popup Widget
 */
class PopupFormToggle {

    /**
     * Code For Popups In custom Widget
     *
     * @param cta_elements
     */
    constructor(cta_elements) {
        this.cta_elements = cta_elements;
        this.modalActive = null;
        this.modalWrapper = null;

        // Define basic events
        this.eventToggle();
    }

    /**
     * Set to state Popup Node
     *
     * @param modalNode
     */
    set setModalActive(modalNode) {
        this.modalActive = modalNode;
    }

    /**
     * Set to state Popup Wrapper
     *
     * @param modalWrapper
     */
    set setModalWrapper(modalWrapper) {
        this.modalWrapper = modalWrapper;
    }

    /**
     * Main Method for Open Popup
     *
     * @param selectedModal
     */
    openModal(selectedModal) {
        // Set state active modal
        this.setModalActive = selectedModal;
        this.setModalWrapper = this.modalActive.parentNode
        this.modalWrapper.classList.add('active');
        this.bodyToggleState(1, this.modalActive.id);

        // Init overlay trigger
        this.eventToggleOverlay();

        // Init Toggle Icon
        this.eventToggleIcon();
    };

    /**
     * Main Method for close modal
     */
    closeModal() {
        // Set state active modal
        this.modalWrapper.classList.remove('active');
        this.bodyToggleState(0, this.modalActive.id);
        this.setModalWrapper = null;
        this.setModalActive = null;
    }

    /**
     * Method for toggle main and popup id class in body
     *
     * @param state
     * @param modalName
     */
    bodyToggleState(state, modalName) {
        state
            ? document.body.classList.add('popup-form-open', modalName)
            : document.body.classList.remove('popup-form-open', modalName)
    }

    /**
     * Main Toggle Popup (open|close)
     */
    eventToggle() {
        this.cta_elements && this.cta_elements.forEach(item => {
            item.addEventListener("click", e => {
                e.preventDefault();

                (!this.modalActive)
                    ? this.openModal(document.getElementById(e.currentTarget.getAttribute("data-popup")))
                    : this.closeModal();
            })
        })
    }

    /**
     * Method Event toggle modal by clock on overlay popup (wrapper popup)
     */
    eventToggleOverlay() {
        this.modalWrapper && this.modalWrapper.addEventListener("click", e => {
            if (e.target.classList.contains('wrapper_popup_widget'))
                this.closeModal();
        })
    }

    /**
     * Event Close Popup by click on inner popup icon
     */
    eventToggleIcon() {
        this.modalActive && this.modalActive.querySelector('.icon-close-modal').addEventListener('click', () => {
            this.closeModal();
        });
    }
}

export default PopupFormToggle;
